import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'billing',
    loadChildren: () => import('./features/billing/billing.routes').then((r) => r.BILLING_ROUTES),
  },
  { path: '', redirectTo: 'billing', pathMatch: 'full' },
  { path: '**', redirectTo: 'billing' },
];
